import { 
  DEACTIVATE_FACULTY, ACTIVATE_FACULTY, CREATE_FACULTY, UPDATE_FACULTY, GET_ERRORS, GET_FACULTIES 
} from './types';
import { getErrorMessage } from '../utils/util.errors';
import services from '../config/services';
import axios from 'axios';

const URL_GET_FACULTIES      = process.env.REACT_APP_API_URL + services.getFacultyByFilters;
const URL_DEACTIVATE_FACULTY = process.env.REACT_APP_API_URL + services.deactivateFaculty;
const URL_ACTIVATE_FACULTY   = process.env.REACT_APP_API_URL + services.activateFaculty;
const URL_UPDATE_FACULTY     = process.env.REACT_APP_API_URL + services.updateFaculty;
const URL_CREATE_FACULTY     = process.env.REACT_APP_API_URL + services.addFaculty;

export const getFaculties = (params = null) => dispatch => {

	let url = URL_GET_FACULTIES;
	if(params){
		if(params.hasOwnProperty('is_active')){
			url += '?is_active=' + params.is_active;
		}
	}


	axios
		.get(url)
		.then(res => {
			dispatch({
				type: GET_FACULTIES,
				payload: {
					message: res.data.result
				}
			})
		})
		.catch(error => {
			dispatch({
				type: GET_ERRORS,
				payload: getErrorMessage(error)
			})
		});
};

export const createFaculty = (faculty) => dispatch => {
	axios.post(URL_CREATE_FACULTY, faculty)
		.then(res => {
			if (res.data.status.code === '0000')
				dispatch({
					type: CREATE_FACULTY,
					payload: {
						message: res.data
					}
				})
		})
		.catch(error => {
			dispatch({
				type: GET_ERRORS,
				payload: getErrorMessage(error)

			})
		});
}

export const updateFaculty = (faculty) => dispatch => {

	axios.patch(URL_UPDATE_FACULTY, faculty)
		.then(res => {
			if (res.data.status.code === '0000')
				dispatch({
					type: UPDATE_FACULTY,
					payload: {
						message: res.data
					}
				})
		})
		.catch(error => {
			dispatch({
				type: GET_ERRORS,
				payload: getErrorMessage(error)
			})
		});
}

export const activateFaculty = (id) => dispatch => {
	let url = URL_ACTIVATE_FACULTY + id;

	axios.patch(url)
		.then(res => {
			if (res.data.status.code === '0000')
				dispatch({
					type: ACTIVATE_FACULTY,
					payload: {
						message: res.data
					}
				})
		})
		.catch(error => {
			dispatch({
				type: GET_ERRORS,
				payload: getErrorMessage(error)
			})
		});
}

export const deactivateFaculty = (id) => dispatch => {
	axios
		.delete(URL_DEACTIVATE_FACULTY + id)
		.then(res => {
			dispatch({
				type: DEACTIVATE_FACULTY,
				payload: res.data
			})
		})
		.catch(error => {
			dispatch({
				type: GET_ERRORS,
				payload: getErrorMessage(error)
			})
		});
};